import { registerModal } from 'features/Modal/ModalRegistry'
import FlowCreateModal from './FlowCreateModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'FLOW_CREATE'
registerModal(modalType, FlowCreateModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./src/features/Flows/FlowCreateModal/FlowCreateModal.action.js